export const black = '#2d2d2d'
export const white = '#ffffff'
export const grey = '#b4b4b4'
